import { createContext } from 'react';

const TerminalContext = createContext({});

export default TerminalContext;
